module.exports = __webpack_public_path__ + "static/media/tutorial-dashboard-background.a15ae8fb.svg";